define('bwp/social/google',['bwp/loader'], function(loader)
{
  if (document.getElementsByClassName('g-plusone').length > 0) {
    loader.load_api('https://apis.google.com/js/platform.js');
  }
});

